module.exports = __webpack_public_path__ + "static/img/juhuaR507A.e4171ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR507A.jpg
// module id = 2Yo+
// module chunks = 1